import React, { createContext, useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useBrandFont from 'customHooks/useBrandFont';

export const ThemeContext = createContext();

const BrandThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('');
  const fontFamily = useBrandFont(theme.replace('theme-', ''));

  // Update the theme by adding the respective class to the body element
  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  const setThemeBrand = (brand) => {
    setTheme(`theme-${brand}`);
  };

  let materialTheme = createTheme({
    typography: {
      fontFamily: [fontFamily],
    },
  });

  return (
    <ThemeContext.Provider value={{ theme, setThemeBrand }}>
      <ThemeProvider theme={materialTheme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default BrandThemeProvider;